import React from 'react';
import { Box } from '@rebass/grid';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Autocomplete } from '@amtrav/view-components';

const Instructions = styled(Box)`
  /* font-size: 14px; */
`;

const KeyboardHint = styled(Autocomplete.DropdownHint)`
  padding: 8px 16px;
  margin: 24px -16px -16px;
`;

const SearchTypeWrapper = styled(Box)`
  overflow: hidden;
`;

const SearchType = styled.span`
  border: 1px solid #ddd;
  display: inline-flex;
  padding: 6px;
  border-radius: 4px;
  white-space: nowrap;
`;

const Key = styled.span`
  display: inline-block;
  padding: 3px 5px;
  color: black;
  vertical-align: middle;
  background-color: #fff;
  border-bottom-color: #bbb;
  border: 1px solid #bbb;
  border-radius: 6px;
  box-shadow: inset 0 -1px 0 #bbb;
  margin: 0 3px 0;
  min-width: 24px;
  text-align: center;
`;

const Hint = ({ hasText = false }) => (
  <Box p={3}>
    <Instructions mb={3}>{hasText ? 'Continue' : 'Begin'} typing to...</Instructions>
    <SearchTypeWrapper mb={3}>
      <SearchType>navigate to a page</SearchType>
    </SearchTypeWrapper>
    <SearchTypeWrapper mb={3}>
      <SearchType>search the knowledge base</SearchType>
    </SearchTypeWrapper>
    <SearchTypeWrapper mb={3}>
      <SearchType>go to a person&apos;s profile</SearchType>
    </SearchTypeWrapper>
    <SearchTypeWrapper>
      <SearchType>look up a booking number</SearchType>
    </SearchTypeWrapper>
    <KeyboardHint>
      <Box pr={1}>
        Open <i>Quick search</i> with
      </Box>
      {window.navigator.platform.includes('Mac') ? <Key>⌘</Key> : <Key>Ctrl</Key>} + <Key>K</Key>
    </KeyboardHint>
  </Box>
);

Hint.propTypes = {
  hasText: PropTypes.bool,
};

export default Hint;
